import { useId } from "react";

/** The workbench mark — the same drawing as public/favicon.svg, so the tab and the app match. */
export function Logo({ size = 26 }: { size?: number }) {
  // Each copy needs its own gradient id: duplicate ids resolve to whichever came first.
  const gradient = useId();
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 32 32" className="shrink-0">
      <defs>
        <linearGradient id={gradient} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#E65C00" />
          <stop offset="0.55" stopColor="#FF7700" />
          <stop offset="1" stopColor="#FFC078" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="5" fill="#121315" />
      <g fill="none" stroke="#B9B2A6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5.5 25.5 16 18.5 26.5 25.5" opacity="0.3" />
        <path d="M5.5 19.5 16 12.5 26.5 19.5" opacity="0.62" />
      </g>
      <path
        d="M5.5 13.5 16 6.5 26.5 13.5"
        fill="none"
        stroke={`url(#${gradient})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
